// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"13":"955285c351d63326","2888":"0a172b79161e2285"}[chunkId] + ".css";
};